module.exports = __webpack_public_path__ + "img/image27@3x.45f1ab6b.png";